/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import axios from 'axios';
import Loading from 'app/components/common/Loading.jsx';
import BloggerOutput from 'app/components/SubaccountSelector/BloggerOutput.jsx';
import DiscordOutput from 'app/components/SubaccountSelector/DiscordOutput.jsx';
import FacebookInput from 'app/components/SubaccountSelector/FacebookInput.jsx';
import FacebookOutput from 'app/components/SubaccountSelector/FacebookOutput.jsx';
import GMBOutput from 'app/components/SubaccountSelector/GMBOutput.jsx';
import InstagramInput from 'app/components/SubaccountSelector/FacebookInput.jsx';
import InstagramOutput from 'app/components/SubaccountSelector/InstagramOutput.jsx';
import LinkedInOutput from 'app/components/SubaccountSelector/LinkedInOutput.jsx';
import PinterestOutput from 'app/components/SubaccountSelector/PinterestOutput.jsx';
import RedditOutput from 'app/components/SubaccountSelector/RedditOutput.jsx';
import SlackOutput from 'app/components/SubaccountSelector/SlackOutput.jsx';
import TumblrOutput from 'app/components/SubaccountSelector/TumblrOutput.jsx';
import WordpressSelector from 'app/components/SubaccountSelector/WordpressSelector.jsx';
import SubaccountSubscriptionModal from 'app/components/Subscription/SubaccountSubscriptionModal.jsx';
import FullPageModal from 'app/components/common/FullPageModal.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import * as _ from 'underscore';
import { compose } from 'redux';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import ComponentWithRouter from 'app/components/Routers/ComponentWithRouter.jsx';

let timeoutID = 0;

class SubaccountSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            credID: '',
            rID: '',
            psID: 0,
            postRecent: 0,
            mode: '',
            idField: 'id',
            subaccounts: [],
            sortedSubs: {},
            subaccountStats: {},
            pollUrl: '',
            status: 'init',
            serviceID: 0,
            error: null,
            selectedSocials: [],
            requiresUpgrade: false,
            showModal: false,
            showFooter: true,
            finalUrl: '',
            subtype: 0
        };

        this.poll = this.poll.bind(this);
        this.getSubaccounts = this.getSubaccounts.bind(this);
        this.onSubaccountClick = this.onSubaccountClick.bind(this);
        this.sortSubaccounts = this.sortSubaccounts.bind(this);
        this.createBatch = this.createBatch.bind(this);
        this.chooseSub = this.chooseSub.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.isOverTheLimit = this.isOverTheLimit.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.cancelAction = this.cancelAction.bind(this);
        this.toggleFooter = this.toggleFooter.bind(this);

    }

    static getDerivedStateFromProps(props, state) {

        if (!state.credID && props.authState.credID) {
            let parts = props.authState.credID.split("_"),
                finalUrl = '',
                rID = 0,
                psID = 0,
                subtype = 0;

            psID = parseInt(parts[1]);

            if (parts.length === 4) {
                rID = parts[2];
            }

            if (props.router.query && props.router.query.final !== undefined) {
                finalUrl = decodeURIComponent(props.router.query.final);
            }

            if (props.router.query && props.router.query.ast !== undefined && props.router.query.ast !== 0) {
                subtype = parseInt(props.router.query.ast);
            }

            // we got what we needed, clean up the auth state so if the user navigates away
            // they don't trigger a creation attempt and an error
            props.resetAuthState();

            return {
                credID: props.authState.credID,
                mode: parts[0],
                finalUrl,
                rID,
                psID,
                subtype
            };
        }

        return null;

    }

    componentDidMount() {

        // ensure the socials are loaded
        if (this.props.socials.list.length === 0) {
            this.props.getSocials();
        }

    }

    componentWillUnmount() {

        if (timeoutID) {
            window.clearTimeout(timeoutID);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.status === 'init' && this.state.credID) {
            this.getSubaccounts();
        }

        if (Object.keys(prevProps.socials.batchCreates).length === 0 && Object.keys(this.props.socials.batchCreates).length > 0) {
            let nextUrl = this.state.finalUrl.replace(this.props.app.config.appUrl, "");
            this.props.router.navigate(nextUrl);
        }

        if (!_.isEqual(prevProps.user.perms.resources, this.props.user.perms.resources)) {
            this.isOverTheLimit(this.state.selectedSocials.length);
        }

        if (!_.isEqual(prevProps.user.detail, this.props.user.detail)) {
            this.isOverTheLimit(this.state.selectedSocials.length);
        }

        let errors = this.props.getApiErrors(['SOCIAL_CREATE_BATCH']);
        if (errors.length) {
            if (errors[0].errors !== undefined && errors[0].errors.perms !== undefined) {
                this.props.getUserPerms();
                this.setState({
                    status: 'error',
                    error: {
                        message: "Sorry, we couldn't create those socials.",
                        detail: "You'll need to create or modify a plan to continue."
                    }
                });
                this.props.deleteApiError(['SOCIAL_CREATE_BATCH']);
            }
        }

    }

    poll() {
        if (this.state.credID) {
            if (mixpanel) {
                mixpanel.track("Subaccounts Selector - Polling", {
                    state: this.state.credID,
                    subtype: this.state.subtype
                });
            }
            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Subaccounts Selector - Polling',
                    event_data: {
                        subtype: this.state.subtype
                    }
                })
            }
            if (this.state.pollUrl !== '') {
                axios({
                    url: this.state.pollUrl,
                    method: 'GET',
                    withCredentials: true,
                    responseType: 'json'
                })
                .then((response) => {
                    if (response.data.status !== 'ok') {
                        timeoutID = window.setTimeout(this.poll, 2000);
                    } else {
                        this.getSubaccounts();
                        timeoutID = 0;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        if (mixpanel) {
                            mixpanel.track("Subaccounts Selector - Poll Error", {
                                state: this.state.credID,
                                subtype: this.state.subtype,
                                error: error.response
                            });
                        }
                        if (this.props.recordEvent) {
                            this.props.recordEvent({
                                pub_id: this.props.user.detail.id,
                                event_name: 'Subaccounts Selector - Poll Error',
                                event_data: {
                                    subtype: this.state.subtype,
                                    error: error.response
                                }
                            })
                        }
                        this.setState({
                            status: 'error',
                            error: {
                                message: error.response.data.error,
                                detail: error.response.data.details
                            }
                        });
                    }
                });
            }
        }

    }

    getSubaccounts() {
        if (this.state.credID) {
            if (mixpanel) {
                mixpanel.track("Subaccounts Selector - Init", {
                    state: this.state.credID,
                    subtype: this.state.subtype
                });
            }
            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Subaccounts Selector - Init',
                    event_data: {
                        subtype: this.state.subtype
                    }
                })
            }
            axios({
                url: '/remote/subacct_api?state=' + this.state.credID,
                method: 'GET',
                withCredentials: true,
                responseType: 'json'
            })
            .then((response) => {
                if (response.data.status === 'pending') {
                    if (mixpanel) {
                        mixpanel.track("Subaccounts Selector - Start Poll", {
                            state: this.state.credID,
                            subtype: this.state.subtype
                        });
                    }
                    if (this.props.recordEvent) {
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'Subaccounts Selector - Start Poll',
                            event_data: {
                                subtype: this.state.subtype
                            }
                        })
                    }
                    this.setState({
                        pollUrl: response.data.pollUrl,
                        status: response.data.status,
                        serviceID: response.data.svcID,

                    }, () => {
                        timeoutID = window.setTimeout(this.poll, 2000);
                    });

                } else {
                    if (mixpanel) {
                        mixpanel.track("Subaccounts Selector - Get Results", {
                            state: this.state.credID,
                            subtype: this.state.subtype,
                            stats: response.data.stats
                        });
                    }
                    if (this.props.recordEvent) {
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'Subaccounts Selector - Get Results',
                            event_data: {
                                subtype: this.state.subtype,
                                stats: response.data.stats
                            }
                        })
                    }
                    this.setState({
                        pollUrl: '',
                        subaccounts: response.data.subaccounts,
                        status: 'loadComplete',
                        serviceID: response.data.svcID,
                        subaccountStats: response.data.stats,
                        idField: response.data.idField
                    }, () => {
                        this.sortSubaccounts();
                    });
                }
            })
            .catch((error) => {
                if (error.response) {
                    if (mixpanel) {
                        mixpanel.track("Subaccounts Selector - subacct_api error", {
                            state: this.state.credID,
                            subtype: this.state.subtype,
                            error: error.response
                        });
                    }
                    if (this.props.recordEvent) {
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'Subaccounts Selector - subacct_api error',
                            event_data: {
                                subtype: this.state.subtype,
                                error: error.response
                            }
                        })
                    }
                    this.setState({
                        status: 'error',
                        error: {
                            message: error.response.data.error,
                            detail: error.response.data.details
                        }
                    });
                }
            });
        }
    }

    isOverTheLimit(nextCount) {
        let requiresUpgrade = this.state.requiresUpgrade,
            constants = this.props.app.config.constants;

        if (this.state.mode === 'POST') {
            // legacy account have unlimited socials, so... knock yerselves out!
            if (this.props.user.perms.resources.outputsAvailable !== -1) {
                if ((this.props.user.perms.resources.outputsInUse + nextCount) > parseInt(this.props.user.perms.perms.hardLimitOutputs)) {
                    requiresUpgrade = true;
                } else {
                    requiresUpgrade = false;
                }
            }
            // Catch the free users who shouldn't have more than one social of a type
            if (!requiresUpgrade &&
                this.props.user.detail.isClient === false &&
                this.props.user.detail.pubLevel <= constants.PUB_LEVEL_1
            ) {
                let typeCount = this.props.socials.list.filter(({psID}) => psID === this.state.psID);
                if ((typeCount.length && nextCount) || nextCount > 1) {
                    requiresUpgrade = true;
                }
            }
        } else if (this.state.mode === 'INPUT') {
            // legacy accounts also have unlimited inputs, so... get piggy wid it!
            if (this.props.user.perms.resources.inputsAvailable !== -1) {
                if ((this.props.user.perms.resources.inputsInUse + nextCount) > parseInt(this.props.user.perms.perms.hardLimitInputs)) {
                    requiresUpgrade = true;
                } else {
                    requiresUpgrade = false;
                }
            }
        }

        this.setState({
            requiresUpgrade
        });

        return requiresUpgrade;
    }

    onSubaccountClick(e) {
        let id = e.currentTarget.dataset.id,
            type = e.currentTarget.dataset.type,
            group = e.currentTarget.dataset.group,
            nextSocials = [...this.state.selectedSocials],
            constants = this.props.app.config.constants;

        if (id) {
            // Anything that's not posting (and not posting to discord) can only select one
            // or if you're on the old pro plan, single service only
            if (
                this.props.user.detail.pubLevel <= constants.PUB_LEVEL_1 ||
                this.state.mode !== "POST" ||
                (this.state.mode === "POST" && this.state.serviceID === constants.POST_SVC_DISCORD)
            ) {
                if (this.state.selectedSocials.length === 0) {
                    nextSocials.push(id);
                } else {
                    if (this.state.selectedSocials.indexOf(id) !== -1) {
                        nextSocials = [];
                    } else {
                        nextSocials = [id];
                    }
                }

            } else {
                if (this.state.selectedSocials.indexOf(id) === -1) {
                    // check if user can add another social or needs to pay up
                    let newCount = nextSocials.length + 1;
                    this.isOverTheLimit(newCount);

                    nextSocials.push(id);

                } else {
                    let newCount = nextSocials.length - 1;
                    this.isOverTheLimit(newCount);

                    nextSocials.splice(this.state.selectedSocials.indexOf(id), 1);

                }
            }

            this.setState({
                selectedSocials: nextSocials
            });
        }

    }

    selectAll(select) {
        let nextSelectedSocials = [],
            i = 0;

        if (select) {
            for (i = 0; i < this.state.sortedSubs.available.length; ++i) {
                nextSelectedSocials.push(this.state.sortedSubs.available[i].id.toString());
            }
            for (i = 0; i < this.state.sortedSubs.inUseAvailable.length; ++i) {
                nextSelectedSocials.push(this.state.sortedSubs.inUseAvailable[i].id.toString());
            }

        }

        // check if we need to request that the user upgrades before proceeding to add all
        this.isOverTheLimit(nextSelectedSocials.length);

        this.setState({
            selectedSocials: nextSelectedSocials
        });
    }

    sortSubaccounts() {
        let nextSortedSubs = {
                available: [],
                inUseAvailable: [],
                unavailable: [],
                ineligible: [],
                unverified: []
            },
            nextSelectedSocials = [...this.state.selectedSocials],
            constants = this.props.app.config.constants;

        if (this.state.subaccounts) {
            for (let key in this.state.subaccounts) {
                let subaccount = this.state.subaccounts[key];
                if (subaccount.verified !== undefined && !subaccount.verified) {
                    nextSortedSubs.unverified.push(subaccount);
                } else if (subaccount.canPost !== undefined && !subaccount.canPost) {
                    nextSortedSubs.ineligible.push(subaccount);
                } else if (subaccount.inuseStatus !== undefined) {
                    if (subaccount.inuseStatus === 2) {
                        nextSortedSubs.inUseAvailable.push(subaccount);
                    } else if (subaccount.inuseStatus === 1 || subaccount.inuseStatus === true) {
                        nextSortedSubs.unavailable.push(subaccount);
                    } else {
                        nextSortedSubs.available.push(subaccount);
                    }
                } else {
                    nextSortedSubs.available.push(subaccount);
                }
            }
        }

        // What follows is the autoselect code. May it be commented out in peace for the rest of our days.
        // if (this.state.subtype !== constants.FB_SUBTYPE_GROUP) {
        //     if (nextSelectedSocials.length === 0 &&
        //         (nextSortedSubs.available.length > 0 ||
        //         nextSortedSubs.inUseAvailable.length > 0)) {
        //         if (nextSortedSubs.available.length > 0) {
        //             nextSelectedSocials.push(nextSortedSubs.available[0][this.state.idField]);
        //         } else {
        //             nextSelectedSocials.push(nextSortedSubs.inUseAvailable[0][this.state.idField]);
        //         }
        //     }
        // }

        this.setState({
            sortedSubs: nextSortedSubs,
            selectedSocials: nextSelectedSocials
        });
    }

    createBatch() {

        if (this.state.selectedSocials) {
            this.props.createBatchSocials({
                credID: this.state.credID,
                psID: this.state.serviceID,
                externalIDs: this.state.selectedSocials,
                rID: this.state.rID,
                postRecent: this.state.postRecent
            });
        }

    }

    chooseSub() {
        let formData = new FormData();

        formData.append(this.state.idField, this.state.selectedSocials[0]);

        axios({
            url: '/remote/subacct_api?state=' + this.state.credID,
            data: formData,
            headers: { "Content-type": "multipart/form-data" },
            method: 'POST',
            withCredentials: true,
            responseType: 'json'
        })
        .then((response) => {
            if (response.data.success === 1) {
                window.location.href = decodeURIComponent(response.data.finalUrl);
            }
        })
        .catch((error) => {
            if (error.response) {
                this.setState({
                    status: 'error',
                    error: {
                        message: error.response.data.error,
                        detail: error.response.data.details
                    }
                });
            }
        });

    }

    toggleModal(state) {

        this.setState({
            showModal: state
        });

    }

    cancelAction(e) {
        let nextUrl = this.state.finalUrl.replace(this.props.app.config.appUrl, "");
        e.preventDefault();
        this.props.router.navigate(nextUrl);
    }

    toggleFooter(state) {
        this.setState({
            showFooter: state
        });
    }

    render() {
        let content = null,
            header = '',
            ServiceElement = null,
            stickyFooter = null,
            status = null,
            cancelButton = null,
            actionButton = null,
            actionButtonClass = 'form-button chooser-submit',
            actionDelegate = null,
            constants = this.props.app.config.constants;

        if (this.state.status !== 'loadComplete' && this.state.status !== 'error') {
            content = (
                <Loading/>
            );
        } else if (this.state.status === 'error' && this.state.serviceID === 0) {
            content = (
                    <div className="chooser-error">
                        <div>{this.state.error.message}</div>
                        <div className="error-detail">{this.state.error.detail}</div>
                        <a href={this.state.finalUrl} className="btn-primary reverse-fixed">Continue</a>
                    </div>
            );
        } else {
            switch (this.state.serviceID) {
                case constants.POST_SVC_BLOGGER:
                    ServiceElement = BloggerOutput;
                    break;

                case constants.POST_SVC_DISCORD:
                    ServiceElement = DiscordOutput;
                    break;

                case constants.INPUT_TYPE_FACEBOOK_PAGE:
                    ServiceElement = FacebookInput;
                    break;

                case constants.POST_SVC_FACEBOOK:
                    ServiceElement = FacebookOutput;
                    break;

                case constants.POST_SVC_GMYBUSINESS:
                    ServiceElement = GMBOutput;
                    break;

                case constants.INPUT_TYPE_INSTAGRAM_BUSINESS:
                    ServiceElement = InstagramInput;
                    break;

                case constants.POST_SVC_INSTAGRAM_BUSINESS:
                    ServiceElement = InstagramOutput;
                    break;

                case constants.POST_SVC_LINKEDIN:
                    ServiceElement = LinkedInOutput;
                    break;

                case constants.POST_SVC_PINTEREST:
                    ServiceElement = PinterestOutput;
                    break;

                case constants.POST_SVC_REDDIT:
                    ServiceElement = RedditOutput;
                    break;

                case constants.POST_SVC_SLACK:
                    ServiceElement = SlackOutput;
                    break;

                case constants.POST_SVC_TUMBLR:
                    ServiceElement = TumblrOutput;
                    break;

                case constants.POST_SVC_WORDPRESS:
                case constants.GENERIC_SVC_WORDPRESS:
                    ServiceElement = WordpressSelector;
                    break;

                default:
                    break;
            }

            if (this.state.selectedSocials.length > 0) {
                let socialLabel = (this.state.selectedSocials.length === 1) ? 'social' : 'socials'
                status = `${this.state.selectedSocials.length} ${socialLabel} selected`;
            }

            if (this.state.requiresUpgrade) {
                status += ". Upgrade to add all socials."
                actionButton = (
                    <button className={actionButtonClass} onClick={() => {
                            this.props.addModal(
                                <SubaccountSubscriptionModal
                                    {...this.props}
                                    {...this.state}
                                    toggleModal={this.toggleModal}/>
                            );
                            this.toggleModal(true);
                        }}>
                            Upgrade
                    </button>
                );
            } else if (this.state.subaccounts.length === 0 ||
                    (Object.keys(this.state.sortedSubs).length &&
                        this.state.sortedSubs.available.length === 0 &&
                        this.state.sortedSubs.inUseAvailable.length === 0)) {
                actionButton = (
                    <button className={actionButtonClass} onClick={(e) => {
                            this.cancelAction(e);
                        }}>
                        Return
                    </button>
                );
            } else {
                if (this.state.mode === "POST" && this.state.selectedSocials.length > 0) {
                    actionDelegate = this.createBatch;
                } else if (this.state.selectedSocials.length === 0) {
                    actionButtonClass += ' inactive';
                } else {
                    actionDelegate = this.chooseSub;
                }

                actionButton = (
                    <button className={actionButtonClass} onClick={actionDelegate}>
                        Connect
                    </button>
                );

            }

            cancelButton = (
                <a href="#" className='chooser-cancel' onClick={(e) => {
                        this.cancelAction(e);
                    }}>
                    cancel
                </a>
            );

            if (this.state.requiresUpgrade && this.props.appName !== undefined && this.props.appName === "client") {
                actionButton = null;
                status = `Please contact ${this.props.user.detail.clientInfo.organization} to increase capacity.`;
            }

            if (!this.state.showModal || this.props.modals.stack.length === 0) {
                let postRecentToggle = null;
                if (this.state.rID) {
                    postRecentToggle = (
                        <div className="chooser-first-post">
                            <ToggleControl
                                toggleClass="small"
                                labelPlacement="right"
                                activeLabel="Post your most recent item to these socials?"
                                inactiveLabel="Post your most recent item to these socials?"
                                active={this.state.postRecent ? true : false}
                                callback={(e) => {
                                    let checked = (e.currentTarget.dataset.togglestate === "true") ? false : true,
                                        nextPostRecent = this.state.postRecent;

                                    if (checked) {
                                        nextPostRecent = 1;
                                    } else {
                                        nextPostRecent = 0;
                                    }

                                    this.setState({
                                        postRecent: nextPostRecent
                                    });

                                }}/>
                        </div>
                    );
                }

                if (this.state.showFooter) {
                    stickyFooter = (
                        <div className="chooser-actions">
                            <div className="chooser-status">
                                {status}
                            </div>
                            {postRecentToggle}
                            <div className="chooser-buttons">
                                {cancelButton}
                                {actionButton}
                            </div>
                        </div>
                    );
                }
            }

            if (ServiceElement && !this.state.showModal) {
                let title = "Connect your social profiles",
                    onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

                if (onboarding !== null) {
                    title = "Connect a social profile";
                }

                if (this.state.mode === "INPUT") {
                    title = "Choose your social profile";
                }

                content = (
                    <FullPageModal
                        title={title}
                        showClose={false}
                        content={
                            <ServiceElement
                                {...this.props}
                                {...this.state}
                                onSubaccountClick={this.onSubaccountClick}
                                selectAll={this.selectAll}
                                toggleFooter={this.toggleFooter}
                                toggleModal={this.toggleModal}
                                footerControls={stickyFooter}/>
                        }/>
                );
            }
        }

        return (
            <Content>
                {content}
            </Content>
        );
    }
}

const enhance = compose(
    ComponentWithRouter,
    ComponentWithContext
);

export default enhance(SubaccountSelector);
